import React from 'react';
export function GenericCollection({
  title,
  description
}: {
  title: string;
  description: string;
}) {
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-351">
      <div className="max-w-[1800px] mx-auto" data-id="element-352">
        <header className="mb-20 text-center" data-id="element-353">
          <span className="text-[10px] font-display uppercase tracking-[0.5em] mb-4 block text-black/40" data-id="element-354">
            Collection
          </span>
          <h1 className="text-4xl md:text-6xl font-display font-bold tracking-[0.2em] uppercase mb-6" data-id="element-355">
            {title}
          </h1>
          <p className="max-w-xl mx-auto text-sm font-light tracking-widest text-black/60 leading-relaxed uppercase" data-id="element-356">
            {description}
          </p>
        </header>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-357">
          {[1, 2, 3].map(i => <div key={i} className="aspect-[3/4] bg-grey-divider" data-id="element-358" />)}
        </div>
      </div>
    </div>;
}